import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { AnalysisHistoryRecord } from '@paragon/contract-library';

export interface ComponentDesignHistory {
  readonly [analysisSetGuid: string]: AnalysisHistoryRecord;
}

interface AnalysisHistoryState {
  readonly [componentDesignGuid: string]: ComponentDesignHistory | undefined;
}

const initialState: AnalysisHistoryState = {};

const analysisHistorySlice = createSlice({
  name: 'analysisHistory',
  initialState,
  reducers: {
    analysisHistoryLoaded: (state, action: PayloadAction<readonly AnalysisHistoryRecord[]>) => {
      for (const analysisHistoryRecord of action.payload) {
        setAnalysisHistoryRecordInState(state, analysisHistoryRecord);
      }
    },
  },
});

function setAnalysisHistoryRecordInState(
  state: Draft<AnalysisHistoryState>,
  analysisHistoryRecord: AnalysisHistoryRecord,
) {
  const { analysisSetGuid, componentDesignGuid } = analysisHistoryRecord;

  const componentDesignHistory = state[componentDesignGuid];
  if (componentDesignHistory) {
    componentDesignHistory[analysisSetGuid] = analysisHistoryRecord;
  } else {
    state[componentDesignGuid] = { [analysisSetGuid]: analysisHistoryRecord };
  }
}

export const { analysisHistoryLoaded } = analysisHistorySlice.actions;
export const analysisHistory = analysisHistorySlice.reducer;
